import { ToolExecutionStatus } from 'constants/aiChat';

export const workflowToolHandler = async ({ toolName, parameters, context }) => {
  const { loanId, createTask, addCondition, requestDocument, updateLoanStatus } = context;

  try {
    switch (toolName) {
      case 'create_task': {
        const { taskType, description, assigneeId, dueDate, priority } = parameters;

        if (!createTask) {
          return {
            success: false,
            status: ToolExecutionStatus.FAILED,
            error: 'Create task context not available',
          };
        }

        if (!taskType || !description) {
          return {
            success: false,
            status: ToolExecutionStatus.FAILED,
            error: 'Task type and description are required',
          };
        }

        const result = await createTask({
          loanId,
          taskType,
          description,
          assigneeId,
          dueDate,
          priority,
          source: 'ai_chat',
        });

        return {
          success: true,
          status: ToolExecutionStatus.COMPLETED,
          result: {
            taskId: result?.id,
            message: 'Task created successfully',
          },
        };
      }

      case 'add_condition': {
        const { conditionType, description, category, priorTo } = parameters;

        if (!addCondition) {
          return {
            success: false,
            status: ToolExecutionStatus.FAILED,
            error: 'Add condition context not available',
          };
        }

        if (!conditionType || !description) {
          return {
            success: false,
            status: ToolExecutionStatus.FAILED,
            error: 'Condition type and description are required',
          };
        }

        const result = await addCondition({
          loanId,
          conditionType,
          description,
          category,
          priorTo,
          source: 'ai_chat',
        });

        return {
          success: true,
          status: ToolExecutionStatus.COMPLETED,
          result: {
            conditionId: result?.id,
            message: 'Condition added successfully',
          },
        };
      }

      case 'request_document': {
        const { documentType, description, borrowerId, dueDate } = parameters;

        if (!requestDocument) {
          return {
            success: false,
            status: ToolExecutionStatus.FAILED,
            error: 'Request document context not available',
          };
        }

        if (!documentType) {
          return {
            success: false,
            status: ToolExecutionStatus.FAILED,
            error: 'Document type is required',
          };
        }

        const result = await requestDocument({
          loanId,
          documentType,
          description,
          borrowerId,
          dueDate,
          source: 'ai_chat',
        });

        return {
          success: true,
          status: ToolExecutionStatus.COMPLETED,
          result: {
            documentRequestId: result?.id,
            message: 'Document request created successfully',
          },
        };
      }

      case 'update_loan_status': {
        const { status, reason } = parameters;

        if (!updateLoanStatus) {
          return {
            success: false,
            status: ToolExecutionStatus.FAILED,
            error: 'Update loan status context not available',
          };
        }

        if (!status) {
          return {
            success: false,
            status: ToolExecutionStatus.FAILED,
            error: 'Status is required',
          };
        }

        await updateLoanStatus({
          loanId,
          status,
          reason,
          source: 'ai_chat',
        });

        return {
          success: true,
          status: ToolExecutionStatus.COMPLETED,
          result: {
            newStatus: status,
            message: 'Loan status updated successfully',
          },
        };
      }

      default: {
        return {
          success: false,
          status: ToolExecutionStatus.FAILED,
          error: `Unknown workflow tool: ${toolName}`,
        };
      }
    }
  } catch (error) {
    return {
      success: false,
      status: ToolExecutionStatus.FAILED,
      error: error.message || 'Workflow operation failed',
    };
  }
};

export default workflowToolHandler;
